import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faUpload,
  faClock
} from "@fortawesome/free-solid-svg-icons";

export default function ContractorDocuments(props) {

  var styles = {

    card: {
      background: "#fff",
      borderRadius: "10px",
      padding: "18px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      marginBottom: "18px"
    },

    title: {
      fontSize: "14px",
      fontWeight: 700,
      marginBottom: "14px"
    },

    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 12px",
      borderRadius: "8px",
      border: "1px solid rgba(0,0,0,0.10)",
      marginBottom: "10px"
    },

    left: {
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },

    name: {
      fontSize: "13px",
      fontWeight: 600
    },

    meta: {
      fontSize: "12px",
      color: "#666"
    },

    action: {
      fontSize: "12px",
      fontWeight: 700,
      color: "#1f6fe5",
      cursor: "pointer"
    }
  };

  return (
    <>
      <div style={styles.card}>
        <div style={styles.title}>Compliance Documents</div>

        <div style={styles.row}>
          <div style={styles.left}>
            <FontAwesomeIcon icon={faFilePdf} />
            <div>
              <div style={styles.name}>Public Liability Insurance.pdf</div>
              <div style={styles.meta}>
                <FontAwesomeIcon icon={faClock} /> Expires 12 Mar 2026
              </div>
            </div>
          </div>

          <div style={styles.action}>View</div>
        </div>

        <div style={styles.row}>
          <div style={styles.left}>
            <FontAwesomeIcon icon={faFilePdf} />
            <div>
              <div style={styles.name}>CHAS Certificate.pdf</div>
              <div style={styles.meta}>
                <FontAwesomeIcon icon={faClock} /> Expires 21 Jan 2026
              </div>
            </div>
          </div>

          <div style={styles.action}>View</div>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.title}>Policies & Templates</div>

        <div style={styles.row}>
          <div style={styles.left}>
            <FontAwesomeIcon icon={faFilePdf} />
            <div>
              <div style={styles.name}>Generic RAMS Template.pdf</div>
              <div style={styles.meta}>Uploaded 3 months ago</div>
            </div>
          </div>

          <div style={styles.action}>Download</div>
        </div>

        <div style={styles.row}>
          <div style={styles.left}>
            <FontAwesomeIcon icon={faFilePdf} />
            <div>
              <div style={styles.name}>Health & Safety Policy.pdf</div>
              <div style={styles.meta}>Current</div>
            </div>
          </div>

          <div style={styles.action}>Download</div>
        </div>

        <div style={{ marginTop: "14px" }}>
          <span style={styles.action}>
            <FontAwesomeIcon icon={faUpload} /> Upload Document
          </span>
        </div>
      </div>
    </>
  );
}
